// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelPrescriberPrescriberUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelPrescriberPrescriberUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelPrescriberPrescriberUpsearchModel.discriminator = undefined;
UpsearchModelPrescriberPrescriberUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "PrescriberUpsearchModel"
    }
];
//# sourceMappingURL=upsearchModelPrescriberPrescriberUpsearchModel.js.map